// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2993":"218d40be","5847":"218d40be"}[chunkId] + ".chunk.css";
};